enum Type {
  Created = 'Created',
  Edited = 'Edited',
  Deleted = 'Deleted',
}

export default Type;
